// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","headings":"Hero_headings__k2z8y"};